import {
  GET_DATA_FILTERS,
  UPDATE_NEGOCE_FORM,
  GET_DATA_SUBMISSIONS,
  GET_DATA_SYNTHESIS_KPI,
  GET_DATA_SYNTHESIS_SALES_BY_COUNTRY,
  GET_DATA_SYNTHESIS_SALES_BY_WINE,
  GET_DATA_PILOTAGEINTERNE_TOP_NEGOCIANTS,
  GET_DATA_PILOTAGEINTERNE_TOP_CUSTOMERS,
  GET_DATA_PRESENTION_KPIS,
  GET_DATA_RAW
} from '../constants/negoce';

const DEFAULT_STATE = {
  data: {
    campaigns: [],
    campaign_submissions_stats: [],
    synthesis_kpi: null
  },
  form: {
    currentCampaign: null
  }
};

export default (state = DEFAULT_STATE, action) => {
  const { type, payload = {} } = action;
  switch (type) {
    case GET_DATA_FILTERS:
      return { ...state, data: { ...payload } };
    case UPDATE_NEGOCE_FORM:
      return { ...state, form: { ...state.form, ...payload } };
    case GET_DATA_SUBMISSIONS:
      return {
        ...state,
        data: {
          ...state.data,
          ...payload
        }
      };
    case GET_DATA_SYNTHESIS_KPI:
      return {
        ...state,
        data: {
          ...state.data,
          synthesis_kpi: {
            ...state.data.synthesis_kpi,
            ...payload
          }
        }
      };
    case GET_DATA_SYNTHESIS_SALES_BY_COUNTRY:
      return {
        ...state,
        data: {
          ...state.data,
          synthesis_sales_by_country: {
            ...state.data.synthesis_sales_by_country,
            ...payload
          }
        }
      };
    case GET_DATA_SYNTHESIS_SALES_BY_WINE:
      return {
        ...state,
        data: {
          ...state.data,
          synthesis_sales_by_wines: {
            ...state.data.synthesis_sales_by_wines,
            ...payload
          }
        }
      };
    case GET_DATA_PILOTAGEINTERNE_TOP_NEGOCIANTS:
      return {
        ...state,
        data: {
          ...state.data,
          pilotage_interne_top_negociants: {
            ...state.data.pilotage_interne_top_negociants,
            ...payload
          }
        }
      };
    case GET_DATA_PILOTAGEINTERNE_TOP_CUSTOMERS:
      return {
        ...state,
        data: {
          ...state.data,
          pilotage_interne_top_customers: {
            ...state.data.pilotage_interne_top_customers,
            ...payload
          }
        }
      };
    case GET_DATA_PRESENTION_KPIS:
      return {
        ...state,
        data: {
          ...state.data,
          presentation_kpis: {
            ...state.data.presentation_kpis,
            ...payload
          }
        }
      };
    case GET_DATA_RAW:
      return {
        ...state,
        data: {
          ...state.data,
          raw: {
            ...state.data.raw,
            ...payload
          }
        }
      };
    default:
      return state;
  }
};
